module.exports = __webpack_public_path__ + "static/media/Read-Bold_V1100.c9992c20.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Bold_V1100.woff
// module id = 650
// module chunks = 0